import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Keyboard,
  Pressable,
  Alert,
  Image,
  Platform,
  AppState,
  ScrollView,
  ImageBackground,
} from "react-native";
import QRCode from "react-native-qrcode-svg";
import { black, color_main, white } from "../../assets/style/colors";
import { useStore } from "../../store/UserStore";
import {
  setEncrypt,
  setMsgAssistant,
  setMsgTranslate,
  setSecret,
  setServiceUrl,
  setToken,
  setUid,
  setVcode,
} from "../../store/token";
import * as ImSdk from "../../../imsdk/api/index";
import { showToast } from "../../components/Toast";
import { attachConfig, clientIp, PCLogin } from "../../net/service";
import { getLanguage } from "../../language/i18n";
import DeviceInfo from "react-native-device-info";
// 导入 SVG logo
import RoundLogo from "../../assets/svg/ic_round_logo.svg";
import MisoLogo from "../../assets/svg/ic_round_logo_miso.svg";
import { Str_CurrenAccInUse } from "../../language/string_res";
import {
  osName,            // 操作系统名称 (例如: "Mac OS", "Windows", "iOS")
  osVersion,         // 操作系统版本 (例如: "10.15.7", "11")
  browserName,       // 浏览器名称 (例如: "Chrome", "Safari")
  browserVersion,    // 浏览器版本 (例如: "120.0.0")
  deviceType,        // 设备类型 (例如: "desktop", "mobile")
  isDesktop,         // 是否为桌面设备 (boolean)
} from 'react-device-detect';
import { ImageView } from "../../components/ImageView";
import { ErrorCodePermission } from "../../net/http";


type PollStatus = 0 | 1 | 2 | 3;

const QR_EXPIRE_SECONDS = 60;
const POLL_INTERVAL_MS = 1500;

/** 获取公网 IP（仅 Web 生效，带超时与中断） */
const getPublicIP = (timeoutMs = 5000): Promise<string> =>
  new Promise((resolve) => {
    // Safari 兼容性检查
    if (typeof globalThis === "undefined" || typeof fetch === "undefined") {
      console.warn("[QRCodeLogin] 浏览器不支持 fetch API");
      return resolve("");
    }

    let settled = false;
    const done = (ip = "") => {
      if (settled) return;
      settled = true;
      resolve(ip);
    };

    // Safari 可能不支持 AbortController
    let controller: AbortController | null = null;
    try {
      if (typeof AbortController !== "undefined") {
        controller = new AbortController();
      }
    } catch (e) {
      console.warn("[QRCodeLogin] AbortController 不可用");
    }

    const timeoutId = setTimeout(() => {
      if (controller) {
        try {
          controller.abort();
        } catch (e) {
          console.warn("[QRCodeLogin] abort 失败:", e);
        }
      }
      done("");
    }, timeoutMs);

    const fetchOptions: RequestInit = controller
      ? { signal: controller.signal }
      : {};


    // fetch('https://ip-api.com/json', fetchOptions)
    // .then((response) => {
    //   if (!response.ok || response.status !== 200) {
    //     throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    //   }
    //   return response.json();
    // })
    // .then((data) => {
    //   clearTimeout(timeoutId);
    //   done(data?.query || "");
    //   done(data?.ip || ""); // 这个需要vpn才能请求的通
    // })
    clientIp() // 这个需要vpn才能请求的通
      .then((data: any) => {
        clearTimeout(timeoutId);
        done(data?.data?.clientIp || ""); // 这个需要vpn才能请求的通
      })
      .catch((err) => {
        console.warn("[QRCodeLogin] 获取 IP 失败:", err);
        clearTimeout(timeoutId);
        done("");
      });
  });

const MAC_STORAGE_KEY = "__web_mac_address__";

/** 本地兜底 UUID（不用于精确设备标识，仅作弱稳定） */
const genUUID = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

/** Web 侧持久化读取 */
export const readPersistedMac = (): string | undefined => {
  try {
    if (
      Platform.OS === "web" &&
      typeof globalThis !== "undefined" &&
      globalThis.localStorage
    ) {
      const mac = globalThis.localStorage.getItem(MAC_STORAGE_KEY) ?? "";
      if (mac.toString().trim() === "unknown") {
        return undefined;
      }
      return mac || undefined;
    }
  } catch { }
  return undefined;
};

/** Web 侧持久化写入 */
const savePersistedMac = (val: string) => {
  try {
    if (
      Platform.OS === "web" &&
      typeof globalThis !== "undefined" &&
      globalThis.localStorage
    ) {
      globalThis.localStorage.setItem(MAC_STORAGE_KEY, val);
    }
  } catch { }
};

const makeStableMac = async (): Promise<string> => {
  try {
    const id = await DeviceInfo.getUniqueId();
    if (id.toString().trim() === "unknown") {
      return genUUID();
    }
    return String(id);
  } catch {
    return genUUID();
  }
};

export const QRCodeLogin = ({ navigation, route }: any) => {
  console.log("🔧 [QRCodeLogin] 组件开始渲染");

  const isAddAccount = route?.params?.isAddAccount ?? "";
  const lastUid = route?.params?.lastUid ?? "";

  const injectedMac = "";
  const injectedIp = "";

  const { dispatch } = useStore();

  const [mac, _setMac] = useState<string>(injectedMac);
  const [ip, _setIp] = useState<string>(injectedIp);
  const [timestamp, setTimestamp] = useState<string>(() =>
    String(Math.floor(Date.now() / 1000))
  );
  const [leftSeconds, setLeftSeconds] = useState<number>(QR_EXPIRE_SECONDS);
  const [loading] = useState<boolean>(false);
  const [status, setStatus] = useState<PollStatus>(0);

  const macRef = useRef<string>(injectedMac || "");
  const ipRef = useRef<string>(injectedIp || "");
  const timestampRef = useRef<string>(String(Math.floor(Date.now() / 1000)));
  const pollRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const destroyedRef = useRef<boolean>(false);
  const loggingRef = useRef<boolean>(false);

  const language = getLanguage();

  /** 与 state 同步的安全 setter，ref > state，避免闭包老值 */
  const setMacSafe = (val: string) => {
    if (!val.startsWith("web_")) {
      val = `web_${val}`;
    }
    macRef.current = val;
    _setMac(val);
  };
  const setIpSafe = (val: string) => {
    ipRef.current = val;
    _setIp(val);
  };
  const setTimestampSafe = (val: string) => {
    timestampRef.current = val;
    setTimestamp(val);
  };

  // ===== 二维码内容 =====
  const qrPayload = useMemo(
    () => ({ mac, ip, timestamp }),
    [mac, ip, timestamp]);
  const qrValue = useMemo(() => JSON.stringify(qrPayload), [qrPayload]);
  // ===== 初始化：IP、MAC、二维码 =====
  useEffect(() => {
    let disposed = false;

    const initEnv = async () => {
      // 1) IP（Web 侧尽量拿公网地址）
      let finalIp = injectedIp;
      if (!finalIp && Platform.OS === "web") {
        finalIp = await getPublicIP();
      }
      if (!disposed) setIpSafe(finalIp || "");

      // 2) “MAC”/设备标识：跨端稳定 + 持久化
      let finalMac = injectedMac;
      if (!finalMac) {
        const cached = readPersistedMac();
        console.log("=======33333", cached);
        if (cached) {
          finalMac = cached;
        } else {
          finalMac = await makeStableMac();
          console.log("=======44444", finalMac);
          savePersistedMac(finalMac);
        }
      }
      if (!disposed) setMacSafe(finalMac);

      // 3) 初始化二维码
      if (!disposed) refreshQR();
    };

    initEnv();

    return () => {
      disposed = true;
      stopPolling();
      destroyedRef.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ===== 网络/窗口变化：自动重探 IP（Web） =====
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      let retryTimer: ReturnType<typeof setTimeout> | null = null;
      let retryCount = 0;
      let isActive = true; // 防止组件卸载后继续执行

      const reProbe = async (_reason: string) => {
        if (!isActive) return;

        const old = ipRef.current;
        const next = await getPublicIP();
        if (next && next !== old && isActive) {
          setIpSafe(next);
          refreshQR();
        } else if (retryCount < 3 && isActive) {
          // 减少重试次数
          retryCount += 1;
          retryTimer = setTimeout(() => reProbe(`retry-${retryCount}`), 2000); // 增加重试间隔
        } else {
          retryCount = 0;
        }
      };

      const onOnline = () => {
        if (isActive) reProbe("online");
      };
      const onVisibility = () => {
        if (isActive && document.visibilityState === "visible") {
          reProbe("visible");
        }
      };
      const onConnectionChange = () => {
        if (isActive) reProbe("connection-change");
      };

      window.addEventListener("online", onOnline);
      document.addEventListener("visibilitychange", onVisibility);

      const conn: any =
        (navigator as any).connection ||
        (navigator as any).mozConnection ||
        (navigator as any).webkitConnection;
      if (conn && typeof conn.addEventListener === "function") {
        conn.addEventListener("change", onConnectionChange);
      }

      const cleanup = () => {
        isActive = false;
        window.removeEventListener("online", onOnline);
        document.removeEventListener("visibilitychange", onVisibility);
        if (conn && typeof conn.removeEventListener === "function") {
          conn.removeEventListener("change", onConnectionChange);
        }
        if (retryTimer) clearTimeout(retryTimer);
      };
      return cleanup;
    }

    const sub = AppState.addEventListener("change", (s) => {
      if (s === "active") {
        // 需要强制刷新可开启
        // refreshQR();
      }
    });
    return () => sub?.remove?.();
  }, []);

  // ===== 倒计时自动刷新二维码 =====
  useEffect(() => {
    if (destroyedRef.current) return;

    const timer = setInterval(() => {
      if (destroyedRef.current) return;

      setLeftSeconds((s) => {
        if (s <= 1) {
          // 延迟执行 refreshQR，避免在 setState 回调中立即调用
          setTimeout(() => {
            if (!destroyedRef.current) {
              refreshQR();
            }
          }, 100);
          return QR_EXPIRE_SECONDS;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // ===== 轮询开始/停止 =====
  const startPolling = () => {
    const tick = async () => {
      if (destroyedRef.current) return;

      const curMac = macRef.current;
      const curIp = ipRef.current;
      const curTs = timestampRef.current; // 与二维码严格一致

      if (!curMac || !curIp || !curTs) {
        pollRef.current = setTimeout(tick, POLL_INTERVAL_MS);
        return;
      }

      try {
        const body = {
          mac: curMac,
          deviceModel: browserName,
          deviceOS: osName + " " + osVersion,
          platform: Platform.OS,
          ip: curIp,
          lang: language,
          timestamp: curTs,
        };

        // console.log("🔄 [QRCodeLogin] 轮询请求参数:", JSON.stringify(body));

        // PC端登录接口 /v1/pc/login
        const resp: any = await PCLogin(body);
        console.log("🔄 [QRCodeLogin] 轮询响应:", JSON.stringify(resp));
        if (resp.code === ErrorCodePermission) {
          return
        }

        if (resp?.code === 0 && resp?.data) {
          const s = resp.data.status as PollStatus;

          if (s === 3 && !loggingRef.current) {
            loggingRef.current = true;
            stopPolling();
            await handleLoginSuccess(resp.data, resp.config);
            return;
          }

          if (s === 2) {
            setStatus(2);
            showToast("授权已取消");
            stopPolling();
            setTimeout(refreshQR, 3000);
            return;
          } else if (s === 1) {
            setStatus(1);
          }
        }
      } catch (error) {
        console.warn("⚠️ [QRCodeLogin] 轮询请求失败:", error);
        // 网络异常时不显示错误，继续轮询
      } finally {
        if (!destroyedRef.current) {
          pollRef.current = setTimeout(tick, POLL_INTERVAL_MS);
        }
      }
    };

    pollRef.current = setTimeout(tick, POLL_INTERVAL_MS);
  };

  const stopPolling = () => {
    if (pollRef.current) clearTimeout(pollRef.current);
    pollRef.current = null;
  };

  const decryptDynamicSource = (encrypted: string): string => {
    try {
      // 用正则匹配前缀 \d+s
      const match = encrypted.match(/^(\d+)s/);
      // 查找 数字+s格式的开头
      if (!match) return encrypted;
      const n = parseInt(match[1]);
      if (n >= encrypted.length) return encrypted;
      // 获取前n位
      const prefix = encrypted.substring(0, n);
      // 把ns去掉
      const keyFull = prefix.replace(match[0], '');
      // 匹配剩余字符串中的数字
      const numbers = keyFull.match(/\d/g) || [];
      // 用数字作为索引，从keyFull中取出字符拼接位解密需要的key
      const aesKey = numbers.map(num => keyFull.charAt(parseInt(num) - 1)).join('');
      // 获取真正需要解密的内容
      const encryptedStr = encrypted.substring(n);
      const decrypted = CryptoJS.AES.decrypt(encryptedStr, aesKey);
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      return encrypted;
    }
  };


  // ===== 登录成功处理 =====
  const handleLoginSuccess = async (data: any, config: any) => {
    const im = ImSdk.getInstance();
    try {
      console.log("🔄 [QRCodeLogin] 开始处理登录成功", JSON.stringify(data));

      if (!data?.token) {
        throw new Error("未返回登录凭证");
      }
      const finalVcode = data.invite;
      if (isAddAccount) {
        const r = await im.getAuth(lastUid);
        if (finalVcode === r.auth?.vcode && r.auth?.uid === data.uid) {
          showToast(Str_CurrenAccInUse);
          setStatus(0);
          return;
        }
      }

      setUid(data.uid);
      setToken(data.token);
      setSecret(data.secret);
      setEncrypt(data.encrypt);
      setServiceUrl(data.customerServiceUrl);
      setMsgAssistant(data.msgAssistant);
      setMsgTranslate(data.msgTranslate);
      setVcode(finalVcode);

      // TODO: 如有必要, 需请求invite 获取name switch_xxx等信息
      // const switch_regist = data.data.switch_regist || 0;
      // const switch_tab_main = data.data.switch_tab_main || 0;
      // const switch_tab_mine = data.data.switch_tab_mine || 1; // 至少开启一个
      // const switch_rtc = data.data.switch_rtc || 0;
      // 无需本地账号记忆逻辑，账号切换全部依赖SDK
      im.global_emit("global_login", {
        global_login: {
          uid: data.uid,
          token: data.token,
          appkey: data.appkey,
          secret: data.secret,
          encrypt: data.encrypt,
          customerServiceUrl: data.customerServiceUrl,
          msgAssistant: data.msgAssistant,
          msgTranslate: data.msgTranslate,
          vcode: finalVcode,
          // switch_regist,
          // switch_tab_main,
          // switch_tab_mine,
          // switch_rtc
        },
      });

      dispatch({
        type: "REPLACE_TOPIC_SUMMARY_LIST",
        payload: { top: [], normal: [] },
      });

      showToast("登录成功");
      console.log("✅ [QRCodeLogin] 登录处理完成，准备跳转");
      navigation.replace("MainStack", { vcode: finalVcode });
    } catch (e: any) {
      console.error("❌ [QRCodeLogin] 登录处理失败:", e);
      Alert.alert("登录失败", e?.message || "请重试");
      loggingRef.current = false;
      refreshQR();
    }
  };

  // ===== 刷新二维码（强一致流程） =====
  const refreshQR = () => {
    stopPolling();

    const nextTs = String(Math.floor(Date.now() / 1000));
    setTimestampSafe(nextTs); // 同步 ref + state
    setLeftSeconds(QR_EXPIRE_SECONDS);
    setStatus(0);

    // 让 UI 先渲染出新二维码后，再启动轮询
    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(() => startPolling());
    } else {
      setTimeout(() => startPolling(), 0);
    }
  };

  const renderMisoContent = () => (
    <View style={{ flex: 1 }}>
      <ScrollView
        style={{ flex: 1, backgroundColor: "#F6F6F6" }}
        contentContainerStyle={{ flexGrow: 1 }}
        keyboardShouldPersistTaps="handled"
      >
        <Pressable onPress={Keyboard.dismiss} accessible={false} style={{ flex: 1 }}>
          <Pressable style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
            {/* Logo */}
            <View style={{ alignItems: "center", gap: 12 }}>
              <MisoLogo width={80} height={80} />
              <Text style={{ fontSize: 24, fontWeight: "bold", color: "#333" }}>Miso</Text>
            </View>

            {/* 二维码 */}
            <View style={{
              backgroundColor: white,
              marginTop: 22,
              paddingTop: 20,
              borderRadius: 15,
              alignItems: "center"
            }}>
              <View style={styles.qrBox}>
                {loading ? (
                  <Text>加载中...</Text>
                ) : (
                  <>
                    {status === 1 ? (
                      <Image
                        source={require("../../assets/image/qr_scanning_checked.png")}
                        style={{ width: 100, height: 156 }}
                        resizeMode="contain"
                      />
                    ) : (
                      <QRCode
                        value={qrValue}
                            size={170}
                        backgroundColor="#FFFFFF"
                      />
                    )}

                    {/* 动态描述 */}
                    {status === 1 && (
                      <Text style={styles.desc}>需要在手机完成授权...</Text>
                    )}
                    {status === 2 && (
                      <Text style={styles.desc}>
                        授权已取消，请稍后扫码重新授权~
                      </Text>
                    )}
                    {status === 3 && (
                      <Text style={styles.desc}>授权成功，正在登录...</Text>
                    )}
                    {status === 0 && (
                      <Text style={styles.desc}>
                        请使用手机 App 扫描二维码登录
                      </Text>
                    )}
                    {/* <Text style={styles.meta}>二维码 {leftSeconds}s 后刷新</Text> */}
                  </>
                )}
              </View>


              {/* 额外描述框 */}
              <View style={styles.bottomView}>
                <View style={styles.instructionBox}>
                  <View style={styles.instructionItem}>
                    <View style={styles.instructionIndex}>
                      <Text style={styles.instructionIndexText}>1</Text>
                    </View>
                    <Text style={styles.instructionText}>打开 Miso App</Text>
                  </View>

                  <View style={styles.instructionItem}>
                    <View style={styles.instructionIndex}>
                      <Text style={styles.instructionIndexText}>2</Text>
                    </View>
                    <Text style={styles.instructionText}>
                      点击“添加 &gt; 扫描”
                    </Text>
                  </View>

                  <View style={styles.instructionItem}>
                    <View style={styles.instructionIndex}>
                      <Text style={styles.instructionIndexText}>3</Text>
                    </View>
                    <Text style={styles.instructionText}>
                      将手机对准屏幕确认登录
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </Pressable>
        </Pressable>
      </ScrollView>
    </View>
  );


  const gotoAppDownloadPage = () => {
    alert("请前往应用商店下载蜂巢协同APP");
    // if (osName === "Mac OS") {
    //   // 跳转到 App Store
    //   const iosAppId = '6754231428';
    //   const url = `itms-apps://itunes.apple.com/app/id${iosAppId}`;
    //   window.open(url, "_blank");
    // } else if (osName === "windows") {
    //   // window.open("https://appgallery.huawei.com/#/app/C104863543", "_blank");
    // }
  };

  const renderHiveUnifyContent = () => (
    <View style={{ flex: 1 }}>
      <ImageBackground source={require("../../assets/image/icon_QRCodeLogin_Bg.png")} style={{ flex: 1 }}>
      <ScrollView
          style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1 }}
        keyboardShouldPersistTaps="handled"
      >
          <Pressable style={{ flex: 1, justifyContent: "center", alignItems: "center" }} onPress={Keyboard.dismiss} accessible={false}>
            <Pressable style={styles.hiveUnifyBox}>
              {/* Left */}
              <View style={styles.leftBox}>
                {/* Logo */}
                <ImageView source={require("../../assets/image/icon_login_hive_logo.png")} imgStyle={{ width: 95, height: 25 }} style={{ marginTop: 30, marginLeft: 33 }} />
                <View style={styles.leftBottom}>
                  <ImageView source={require("../../assets/image/icon_login_desc.png")} imgStyle={{ width: 206, height: 150 }} />
                  {/* 额外描述框 */}
                  <View style={styles.bottomView}>
                    <View style={styles.instructionBox}>
                      <View style={styles.instructionItem}>
                        <View style={styles.instructionIndex}>
                          <Text style={styles.instructionIndexText}>1</Text>
                        </View>
                        <Text style={styles.instructionText}>打开手机上的蜂巢协同 APP</Text>
                      </View>

                      <View style={styles.instructionItem}>
                        <View style={styles.instructionIndex}>
                          <Text style={styles.instructionIndexText}>2</Text>
                        </View>
                        <Text style={styles.instructionText}>
                          点击“添加 &gt; 扫描”
                        </Text>
                      </View>

                      <View style={styles.instructionItem}>
                        <View style={styles.instructionIndex}>
                          <Text style={styles.instructionIndexText}>3</Text>
                        </View>
                        <Text style={styles.instructionText}>
                          将手机对准屏幕确认登录
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>

              {/* Right */}
              <View style={styles.rightBox}>
                <Text style={styles.rightBoxTitle}>扫码登录</Text>
                {/* 二维码 */}
                <View style={styles.hiveQrBox}>
                  {loading ? (
                    <Text>加载中...</Text>
                  ) : (
                    <>
                      {status === 1 ? (
                        <Image
                          source={require("../../assets/image/qr_scanning_checked.png")}
                          style={{ width: 100, height: 156 }}
                          resizeMode="contain"
                        />
                      ) : (
                        <QRCode
                          value={qrValue}
                            size={180}
                            backgroundColor="#FFFFFF"
                          />
                        )}

                        {status === 1 && (
                          <Text style={styles.desc}>需要在手机完成授权...</Text>
                        )}
                        {status === 2 && (
                          <Text style={styles.desc}>
                            授权已取消，请稍后扫码重新授权~
                          </Text>
                        )}
                        {status === 3 && (
                          <Text style={styles.desc}>授权成功，正在登录...</Text>
                        )}
                        {status === 0 && (
                          <Text style={styles.hiveDesc}>
                            请使用 <Text onPress={gotoAppDownloadPage} style={{ color: color_main }}>蜂巢协同APP</Text> 扫描二维码
                          </Text>
                        )}
                    </>
                  )}
                </View>
              </View>

          </Pressable>
        </Pressable>
      </ScrollView>
      </ImageBackground>
    </View>
  );

  return ImSdk.isMiso ? renderMisoContent() : renderHiveUnifyContent();
};

// ===== 样式 =====
const styles = StyleSheet.create({
  qrBox: {
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 12,
    width: 300,
    elevation: 2,
  },
  meta: {
    marginTop: 8,
    fontSize: 12,
    color: "#777",
  },
  desc: {
    marginTop: 24,
    fontSize: 16,
    color: color_main,
    fontWeight: "600",
    textAlign: "center",
  },
  bottomView: {
    width: 350,
    paddingHorizontal: 60,
    marginBottom: 8,
  },
  instructionBox: {
    paddingBottom: 16,
    paddingLeft: 30,
    alignItems: 'flex-start',
    gap: 8,
  },
  instructionItem: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  instructionIndex: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: color_main,
    marginRight: 6,
  },
  instructionIndexText: {
    color: white,
    fontSize: 14,
    fontWeight: 'bold',
  },
  instructionText: {
    fontSize: 14,
    color: "#000000E5",
    textAlign: 'left',
  },
  hiveUnifyBox: {
    backgroundColor: white,
    borderRadius: 16,
    width: 600,
    height: 350,
    flexDirection: 'row',
    justifyContent: "center",
    alignItems: "center",
    shadowColor: black,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.18,
    shadowRadius: 10,
    elevation: 5,
  },
  leftBox: {
    flex: 1.1,
    justifyContent: 'flex-start',
    height: "100%",
    paddingRight: 35,
  },
  leftBottom: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 32,
  },
  rightBox: {
    flex: 0.9,
    height: "100%",
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightBoxTitle: {
    fontSize: 20,
    color: "#000",
    fontWeight: "bold",
    marginTop: 20,
  },
  hiveQrBox: {
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 12,
    elevation: 2,
  },
  hiveDesc: {
    marginTop: 24,
    fontSize: 12,
    color: black,
    fontWeight: "600",
    textAlign: "center",
  }
});

export default QRCodeLogin;
